/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../app/modules/auth'
import { getProfile } from '../../../../app/modules/auth/core/_requests'
import { useThemeMode } from '../theme-mode/ThemeModeProvider'
import { KTIcon } from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const { logout } = useAuth()
  const intl = useIntl()
  const { data: profile } = useQuery(
    'auth-profile',
    () => getProfile().then((r) => r.data?.data),
    { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  )
  const { menuMode, updateMode, updateMenuMode } = useThemeMode()

  const switchMode = (_mode: 'light' | 'dark' | 'system') => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-auto'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <div
              className='d-flex align-items-center justify-content-center symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
              style={{ height: '50px', width: '50px', backgroundColor: '#E8912D', fontSize: '30px' }}
            >
              {profile?.name?.substr(0, 1)?.toUpperCase()}
            </div>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {profile?.name}
              {profile?.type && (
                <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                  {profile.type}
                </span>
              )}
            </div>
            <span className='fw-bold text-muted fs-7'>{profile?.email}</span>
            {profile?.phone && (
              <span className='text-muted fs-8'>{profile.phone}</span>
            )}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/myprofile'} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.MY_PROFILE', defaultMessage: 'My Profile' })}
        </Link>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <div className='menu-content d-flex align-items-center px-3 py-1'>
          <span className='fw-semibold text-muted fs-7 me-auto'>
            {intl.formatMessage({ id: 'MENU.THEME', defaultMessage: 'Appearance' })}
          </span>
          <div className='d-flex gap-1'>
            <a
              href='#'
              onClick={() => switchMode('light')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'light' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='night-day' className='fs-3' />
            </a>
            <a
              href='#'
              onClick={() => switchMode('dark')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'dark' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='moon' className='fs-3' />
            </a>
            <a
              href='#'
              onClick={() => switchMode('system')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'system' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='screen' className='fs-3' />
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.SIGN_OUT', defaultMessage: 'Sign Out' })}
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
